<template>
  <div :class="isIndex ? '' : 'wrapper'" >
    <base-bread-crumb v-if="!isIndex" :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div>
      <div class="ccui-app-container">
        <!--高级搜索Begin-->
        <div class="ccui-advanced-search-wrapper ccui-clearfix">
          <el-search
           v-if="!isIndex"
            ref="elSearch"
            width="460px"
            :formProp="formData"
            @search="search"
            :isShowSearch="true"
            class="ccui-highsearch no-print"
          >
            <template slot="search">
              <el-date-picker
                v-model="formData.publishTime"
                :searchLabel="$t('page.content.publishTime')"
                clearable
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('page.content.to')"
                :start-placeholder="$t('page.content.startTime')"
                :end-placeholder="$t('page.content.endTime')"
              >
              </el-date-picker>
              <el-input
                v-model.trim="formData.title"
                clearable
                :searchLabel="$t('page.content.title')"
                :placeholder="$t('page.content.titlePlaceholder')"
              ></el-input>
            </template>
            <el-date-picker
              v-model="formData.publishTime"
              :searchLabel="$t('page.content.publishTime')"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              :range-separator="$t('page.content.to')"
              :start-placeholder="$t('page.content.startTime')"
              :end-placeholder="$t('page.content.endTime')"
              slot="searchItem1"
            >
            </el-date-picker>
            <el-input
              v-model.trim="formData.title"
              clearable
              :searchLabel="$t('page.content.title')"
              :placeholder="$t('page.content.titlePlaceholder')"
              slot="searchItem2"
            ></el-input>
          </el-search>
        </div>
        <!--高级搜索End-->
        <!--table表格区域Begin-->
        <div class="ccui-multifunctional-table-wrapper">
          <listBaseTable
            :tableName="tableName"
            :showCheckBox="false"
            :showOp="false"
            :data="tableData"
            :cellStyle="cellStyle"
            :pageNo.sync="pageNo"
            :pageSize.sync="pageSize"
            :pageTotal="pageTotal"
            :fixedTableThead="fixedTableThead"
            :unfixedTableThead="unfixedTableThead"
            border
            @handleList="handleList"
            @select-all="handleCheckAllChange"
            @select="handleCheckChange"
            @selection-change="handleSelectionChange"
          >
            <!--列表中的插槽Begin-->
            <template slot="title" slot-scope="{ row }">
              <el-button
                class="column-btn-ellipsis"
                size="mini"
                type="text"
                @click="check(row)"
              >
                {{ row[title] }}
              </el-button>
            </template>
            <!--列表中的插槽End-->
          </listBaseTable>
        </div>
        <!--table表格区域End-->
      </div>
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
export default {
  name: "list",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  props: {
    isIndex: {
      type: Boolean,
      default: false
    },
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    callInterface: {
      type: Function
    },
    otherParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rowsField: {
      type: String,
      default: "rows"
    },
    title: {
      type: String,
      default: "title"
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: this.$t("page.content.serialNo"),
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true
        },
        {
          label: this.$t("page.content.title"),
          prop: "title",
          checked: true,
          width: 500,
          slot: "title"
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "publishTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0
    };
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowPageLoading: true
      };
      if (
        this.formDataSearch.publishTime &&
        this.formDataSearch.publishTime.length !== 0
      ) {
        this.formDataSearch.publishStartTime = this.formDataSearch.publishTime[0];
        this.formDataSearch.publishEndTime = this.formDataSearch.publishTime[1];
      }
      Object.assign(param, this.formDataSearch, this.otherParams);
      this.$delete(param, "publishTime");
      this.callInterface(param).then(res => {
        if (res.data.code === "0") {
        console.log(res,'res-----------')
          this.tableData = res.data.data[this.rowsField];
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          id: row.noticeInfoId,
          type: this.type,
          supCode: this.$route.query.supCode,
        }
      });
      window.open(url.href, "_blank");
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped></style>
